import {Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'app-time-binding-edit',
    templateUrl: './time-binding-edit.component.html',
    styleUrls: ['./time-binding-edit.component.scss'],
    standalone: false
})
export class TimeBindingEditComponent implements OnInit {

  @Input() numSecs: number;
  @Input() min?: number;
  @Input() max?: number;
  @Output() done = new EventEmitter<number>();
  @Output() validationError = new EventEmitter<'max' | 'min'>();
  minutes = '0';
  hours = '0';
  isEdit = false;
  constructor() { }

  ngOnInit() {
    this.hours = (this.numSecs < 0 ? -1 : 1) * Math.floor(Math.abs(this.numSecs) / 60) + '';
    this.minutes = Math.floor(Math.abs(this.numSecs) % 60) + '';
  }

  tryToClose() {
    this.isEdit = false;
    setTimeout(() => {
      if (!this.isEdit) {
        let hours = parseInt(this.hours, 10);
        let minutes = parseInt(this.minutes, 10);
        let result;

        if (isNaN(hours)) {
          hours = 0;
        }
        if (isNaN(minutes)) {
          minutes = 0;
        }

        if (hours < 0) {
          result = -1 * (Math.abs(hours) * 60 + Math.abs(minutes));

        } else {
          result = Math.abs(hours * 60) + Math.abs(minutes);
        }

        if (this.min !== undefined && result < this.min) {
          result = this.min;
          this.validationError.emit('min');
        }

        if (this.max !== undefined && result > this.max) {
          result = this.max;
          this.validationError.emit('max');
        }

        this.done.emit(result);
      }
    });
  }
  setEditMode() {
    this.isEdit = true;
  }

}
